// src/legal/LegalLinks.jsx
// "Privacy · Terms" — the thin link row shown on the sign-in page, the acceptance and
// pending screens, and under Sign Out in the sidebar.
//
// Opens in a new tab: the pages render in place of the whole app (see App.jsx), so a
// same-tab link from the dashboard would discard whatever the reader was doing.

import React from 'react';
import './LegalPage.css';

export default function LegalLinks({ className = '' }) {
  return (
    <nav className={`lg-links ${className}`.trim()} aria-label="Legal">
      <a href="/#privacy" target="_blank" rel="noopener noreferrer">Privacy</a>
      <span aria-hidden="true"> · </span>
      <a href="/#terms" target="_blank" rel="noopener noreferrer">Terms</a>
    </nav>
  );
}
